// extracted by mini-css-extract-plugin
module.exports = {"form":"Team_form__2NcgY","actionContainer":"Team_actionContainer__3kISm"};